"use client";
import { jsx as c } from "react/jsx-runtime";
import { memo as m } from "react";
import t from "../components/Icon/SvgIcon.js";
const e = (o) => /* @__PURE__ */ c(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ c(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.09 2.62v1.22c.83.07 1.49.76 1.49 1.61v15.44c0 .89-.73 1.62-1.62 1.62H6.04c-.89 0-1.62-.73-1.62-1.62V5.46c0-.85.66-1.54 1.49-1.61l10.82-2.32c.33-.07.67.01.94.22s.42.53.42.87m-1.25 1.21V2.78l-4.91 1.05zm1.12 17.42c.2 0 .37-.17.37-.37V5.45c0-.2-.17-.37-.37-.37H6.04c-.2 0-.37.17-.37.37v15.43c0 .2.17.37.37.37zM8.02 10.97h7.95c.62 0 1.12-.5 1.12-1.12V7.41c0-.62-.5-1.12-1.12-1.12H8.02c-.62 0-1.12.5-1.12 1.12v2.44c0 .62.5 1.12 1.12 1.12m7.82-1.25H8.15V7.54h7.69zm-2.35 6.68h2.48c.62 0 1.12-.5 1.12-1.12v-1.99c0-.62-.5-1.12-1.12-1.12h-2.48c-.62 0-1.12.5-1.12 1.12v1.99c0 .62.5 1.12 1.12 1.12m2.35-1.25h-2.23v-1.73h2.23zm-4.83-1.73H7.53c-.34 0-.63-.28-.63-.63s.28-.63.63-.63h3.48c.34 0 .63.28.63.63s-.28.63-.63.63m-3.48 2.95h3.48c.35 0 .63-.28.63-.63s-.29-.63-.63-.63H7.53c-.35 0-.63.28-.63.63s.29.63.63.63m8.94 2.94H7.53c-.34 0-.63-.28-.63-.63s.28-.63.63-.63h8.94c.34 0 .63.28.63.63s-.28.63-.63.63",
        clipRule: "evenodd"
      }
    )
  }
), l = m(e);
export {
  l as CostcoConnection,
  l as default
};
